export default {
  data() {
    return {
      isMobile: false,
      isSmallScreen: false,
      isMobileUserAgent: /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    };
  },
  created() {
    this.windowResize();
    window.addEventListener('resize', this.windowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResize);
  },
  methods: {
    windowResize() {
      // Using 992 is the value of $screen-md as of today which is set in vendor/assets/stylesheets/startup/bootstrap_variables.scss
      this.isMobile = this.isMobileUserAgent || window.innerWidth < 992;
      this.isSmallScreen = window.innerWidth < 768;
    },
  },
};
